"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputsSelectDrawer = void 0;
const react_1 = __importStar(require("react"));
const input_select_styled_1 = require("./input-select.styled");
const InputsSelectDrawer = (props) => {
    const { withSearch, variants, keyField, valueField, withNotion, onChange, renderAfter, onRenderAfterClick } = props;
    const [filteredVariants, setFilteredVariants] = (0, react_1.useState)(variants);
    const [search, setSearch] = (0, react_1.useState)('');
    const handleSearchInputChange = (e) => {
        const value = e.target.value;
        const newVariants = variants.filter((variant) => variant.value.toLowerCase().includes(value.toLowerCase()));
        setFilteredVariants(newVariants);
        setSearch(value);
    };
    (0, react_1.useEffect)(() => {
        setFilteredVariants(variants);
    }, [variants]);
    return (react_1.default.createElement(input_select_styled_1.StyledSelectDrawer, { withNotion: withNotion },
        withSearch && (react_1.default.createElement("div", { style: { width: 'calc(100% - 16px)', margin: '0px 8px 8px' } },
            react_1.default.createElement(input_select_styled_1.StyledSearch, { name: "filter-select", value: search, onChange: handleSearchInputChange, isColoredIcon: true, icon: "Magnifier", placeholder: "\u041F\u043E\u0438\u0441\u043A", autoComplete: "off", autoFocus: true }))),
        withSearch && !filteredVariants.length && (react_1.default.createElement("div", { style: { color: 'grey', textAlign: 'center', padding: '4px 0' } }, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")),
        react_1.default.createElement(input_select_styled_1.StyledItemsWrapper, null, filteredVariants === null || filteredVariants === void 0 ? void 0 :
            filteredVariants.map((item) => (react_1.default.createElement(input_select_styled_1.StyledSelectItem, { key: item[keyField], onClick: () => onChange(item) },
                item.color && react_1.default.createElement(input_select_styled_1.StyledColorSquare, { color: item.color }),
                item[valueField]))),
            renderAfter && (react_1.default.createElement("div", { onClick: () => (onRenderAfterClick ? onRenderAfterClick(search, variants) : () => { }), style: { padding: '8px 12px 4px 12px' } }, typeof renderAfter == 'function' ? renderAfter() : renderAfter)))));
};
exports.InputsSelectDrawer = InputsSelectDrawer;
//# sourceMappingURL=inputs-select-drawer.js.map